import ChannelListWidget from "./ChannelListWidget";

export default ChannelListWidget;
